var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFolderOpen = function SvgFolderOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C62D1",
    d: "M3.727 18h14.35l2.424-6H6.148z",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C62D1",
    d: "M21.75 10.406h-2.531V7.744a.75.75 0 0 0-.75-.75h-7.383l-2.75-2.63a.2.2 0 0 0-.128-.051H2.25a.75.75 0 0 0-.75.75v13.875c0 .414.335.75.75.75h16.36a.75.75 0 0 0 .695-.47l3.141-7.78a.75.75 0 0 0-.696-1.031M3.188 6h4.417l2.804 2.681h7.122v1.725H5.578a.75.75 0 0 0-.696.469l-1.694 4.2zm14.89 12H3.726l2.42-6h14.354z"
  })));
};
export default SvgFolderOpen;